// frontend/src/services/api/esimAPI.js
import api from "./config";

// frontend/src/services/api/esimAPI.js
const esimAPI = {
  getPackages: async (locationCode = "") => {
    try {
      const response = await api.get("/esim/packages", {
        params: { locationCode },
      });

      if (!response.data.obj?.packageList) {
        console.warn("Unexpected package response format:", response.data);
        return { data: { obj: { packageList: [] } } };
      }
      return response;
    } catch (error) {
      console.error("Error fetching packages:", error);
      throw error;
    }
  },

  // Purchase an eSIM package - package code as string
  purchase: (data) =>
    api.post("/esim/purchase", {
      packageCode: data.packageCode,
      userData: data.userData,
      profileId: data.profileId,
      notes: data.notes,
    }),

  // Get order details
  getOrderDetails: (params = {}) =>
    api.get("/esim/orders", {
      params: {
        page: params.page,
        limit: params.limit,
      },
    }),

  getRecentOrders: (limit = 5) =>
    api.get("/esim/orders/recent", { params: { limit } }),

  // Query eSIM details
  queryESIM: (orderNo = "", iccid = "") =>
    api.get("/esim/query", { params: { orderNo, iccid } }),

  getUsageStats: (iccid) => api.get(`/esim/usage/${iccid}`),

  cancel: (orderNo) => api.post("/esim/cancel", { orderNo }),
  suspend: (iccid) => api.post("/esim/suspend", { iccid }),
  unsuspend: (iccid) => api.post("/esim/unsuspend", { iccid }),
  revoke: (iccid) => api.post("/esim/revoke", { iccid }),
  sendSMS: (iccid, message) => api.post("/esim/sms", { iccid, message }),
};

export default esimAPI;
